import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSvg } from '../Svg';
import { chameleonAvatar } from './Avatar.definition';
import { chameleonAvatarV2 } from './Avatar.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonAvatar({ prefix }), chameleonAvatarV2({ prefix }), chameleonSvg({ prefix }));
}
